import * as React from 'react'

import { TextStyle } from '@material-ui/core/styles/createTypography'
import Typography    from '@material-ui/core/Typography'
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import * as customTheme                               from '../../theme'

interface Props {
  label: string | JSX.Element
  children: string | JSX.Element
  variant?: TextStyle
}

export default ({
  label,
  children,
  variant,
}: Props) => {
  if (typeof children === 'string' && !children.trim().length) return null

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: customTheme.whiteText,
      }
    },
  });

  return (
    children
      ? (
        <MuiThemeProvider theme={theme}>
          <Typography variant={'caption'} color="primary">
            {label}
            <Typography variant={variant} color="primary">
              {children}
            </Typography>
          </Typography>
        </MuiThemeProvider>
      )
      : null
  )
}



// WEBPACK FOOTER //
// ./src/components/atoms/WhiteLabelledText.tsx